@if (careproviderUnit()) {
  <div
    class="w-11 h-11 min-w-11 min-h-11 lg:w-12 lg:h-12 lg:min-w-12 lg:min-h-12 border border-grey-8 relative rounded-full overflow-hidden bg-white">
    @if (logoUrl() && logoUrl() !== '') {
      <img
        [alt]="careproviderUnit().name"
        [ngSrc]="logoUrl()"
        class="object-contain w-full h-full"
        fill="true"
      >
    }
  </div>
  <div class="grow text-left flex flex-col justify-center items-start">
    <div class="text-left text-base font-bold line-clamp-1 pl-0.5">{{ careproviderUnit().name }}</div>
    <app-cpru-small-widgets></app-cpru-small-widgets>
  </div>

  @if (displayBookingBtn()) {
    <div class="hidden justify-end items-center gap-4 lg:flex">
      @for (config of bookingConfigurationData(); track config.id) {
        <app-booking-btn
          [bookingConfigurationData]="config"
          [caregiverContactInfo]="careproviderUnit().caregiverContactInfo"
          [class]="'booking-btn test-booking-btn'"
          [gaEventAction]="
              eventActionEnum.VARDEN_BOOKING_CLICK_MAIN_BOOKING_BTN
            "
          [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
          [gaEventLabel]="careproviderUnit().id.toString()"
          [index]="0"
          [mainCaregiverUnitType]="careproviderUnit().mainCaregiverUnitType"
          [pageType]="pageType()"
          class="grow lg:grow-0 block w-full lg:w-auto lg:inline-block"
        ></app-booking-btn>
      }
      @if (!isHsa()) {
        @for (feature of careproviderUnit().customerFeatures; let i = $index; track feature.id) {
          <app-customer-feature
            [color]="'green'"
            [feature]="feature"
            [index]="i"
            [isCustomer]="careproviderUnit().isCustomer"
            [label]="featureLabel()"
            [pageType]="dLPageTypeEnum.CARE_PROVIDER_PAGE"
            size="lg"></app-customer-feature>
        }
      }
    </div>
  }

}

